export const ENV = {
  API_URL: 'https://planora-api.skozub.pl',
}
